export default function routePointToJson(routePoint) {

    let requestBody = {
        'position': routePoint.position
    }

    if (routePoint.portCode != null && routePoint.portCode != undefined) {
        requestBody.portCode = routePoint.portCode
        return requestBody
    }
    else if (
        routePoint.latitude != null &&
        routePoint.latitude != undefined &&
        routePoint.longitude != null &&
        routePoint.longitude != undefined
    ) {
        requestBody.latitude = routePoint.latitude
        requestBody.longitude = routePoint.longitude
        return requestBody
    }
}